module.exports = __webpack_public_path__ + "static/media/INZ1012.7e5d69ed.pdf";